import { ERROR_CODES } from 'state/error'
import i18n from 'config/i18n'

export const ERROR_MESSAGES: Record<string, any> = {
    title: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterTaskTitle'),
    },
    platform_content_type: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.selectTaskType'),
    },
    platform_content_type_others: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterTaskType'),
    },
    steps: {
        title: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterStepTitle'),
        },
        submission_requirement_description: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterDescriptionRequirement'),
        },
        media_requirement_dos: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterStepRequirement'),
        },
        media_requirement_donts: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterStepRequirement'),
        },
        caption_requirement_dos: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterStepRequirement'),
        },
        caption_requirement_donts: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterStepRequirement'),
        },
        link_in_bio_duration: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterNumberDays'),
        },
        link_in_bio_url: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterUrlLink'),
            [ERROR_CODES.URL_INVALID]: i18n.t('errorMessage.validation.invalidUrlLink'),
        },
        requirement_text: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterDescriptionRequirement'),
        },
        extra_data: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterTitleDescription'),
        },
        media_requirement_tags: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterProfileTag'),
        },
        caption_requirement_hashtags: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterHashtag'),
        },
        event_name: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterEventName'),
        },
        event_information: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterEventDetails'),
        },
        things_to_note: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterInstructionsSubmitProof'),
        },
        product_name: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterProductName'),
        },
        how_to_buy: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterInstructionsPurchaseProduct'),
        },
        blocks: {
            title: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterFieldTitle'),
            },
            description: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t(
                    'errorMessage.campaignEditor.textField.enterDescriptionRequirement',
                ),
            },
            files: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.uploadImageForField'),
            },
            max_photos: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMaximumNumberPhotos'),
                [ERROR_CODES.NUMBER_TOO_LOW]: i18n.t('errorMessage.validation.enterNumberGreaterThanOne'),
            },
        },
    },
    engagementMetrics: {
        [ERROR_CODES.TASK_MUST_HAVE_AT_LEAST_ONE_ENGAGEMENT]: i18n.t('errorMessage.validation.selectEngagementMetric'),
    },
    time_window: {
        start: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.datePicker.selectDate'),
            [ERROR_CODES.END_TIME_MUST_BE_LATER_THAN_START_TIME]: i18n.t(
                'errorMessage.businessLogic.enterEndDateAfterStartDate',
            ),
            [ERROR_CODES.SCHEDULE_MUST_LATER_THAN_PARENT_STEP]: i18n.t(
                'errorMessage.businessLogic.scheduleCantBeEarlierThanPrevious',
            ),
            [ERROR_CODES.PAST_SCHEDULE_UPDATE_NOT_ALLOWED]: i18n.t('errorMessage.businessLogic.startDatePast'),
            [ERROR_CODES.SCHEDULE_MUST_LATER_THAN_NOW]: i18n.t('errorMessage.businessLogic.cantEnterPastDate'),
            [ERROR_CODES.REGISTRATION_SCHEDULE_MUST_START_EARLIER_THAN_TASK]: i18n.t(
                'errorMessage.businessLogic.enterRegistrationStartDateBeforeTasksStart',
            ),
            [ERROR_CODES.SCHEDULE_MUST_START_LATER_THAN_REGISTRATION]: i18n.t(
                'errorMessage.businessLogic.enterStepStartDateAfterRegistrationStart',
            ),
        },
        end: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.datePicker.selectDate'),
            [ERROR_CODES.END_TIME_MUST_BE_LATER_THAN_START_TIME]: i18n.t(
                'errorMessage.businessLogic.enterEndDateAfterStartDate',
            ),
            [ERROR_CODES.SCHEDULE_MUST_LATER_THAN_PARENT_STEP]: i18n.t(
                'errorMessage.businessLogic.scheduleCantBeEarlierThanPrevious',
            ),
            [ERROR_CODES.END_TIME_MUST_BE_N_HOURS_LATER_THAN_PREV_STEP]: i18n.t(
                'errorMessage.businessLogic.stepToStartSevenDaysAfterPrevious',
            ),
            [ERROR_CODES.CAMPAIGN_PAYOUT_DEADLINE_LESS_THAN_END_TIME]: i18n.t(
                'errorMessage.businessLogic.payoutBeforeEndDate',
            ),
            [ERROR_CODES.SCHEDULE_CHANGE_BACKWARD_NOT_ALLOWED]: i18n.t(
                'errorMessage.businessLogic.cantEnterEarlierDate',
            ),
            [ERROR_CODES.SCHEDULE_MUST_LATER_THAN_NOW]: i18n.t('errorMessage.businessLogic.cantEnterPastDate'),
            [ERROR_CODES.REGISTRATION_SCHEDULE_MUST_END_EARLIER_THAN_TASK]: i18n.t(
                'errorMessage.businessLogic.enterRegistrationEndDateBeforeTasksEnd',
            ),
            [ERROR_CODES.SCHEDULE_MUST_END_LATER_THAN_REGISTRATION]: i18n.t(
                'errorMessage.businessLogic.enterStepEndDateAfterRegistrationEnd',
            ),
        },
    },
    payouts: {
        base: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation..enterPayoutAmount'),
            [ERROR_CODES.PAYOUT_NOT_ALLOWED_TO_BE_LOWERED]: i18n.t('errorMessage.businessLogic.cantEnterLowerPayout'),
        },
        min: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMinimumNumberPayout'),
        },
        max: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMaximumNumberPayout'),
        },
        cost: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation..enterPayoutAmount'),
            [ERROR_CODES.PAYOUT_NOT_ALLOWED_TO_BE_LOWERED]: i18n.t('errorMessage.businessLogic.cantEnterLowerPayout'),
        },
        title: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterPayoutTitle'),
        },
        description: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterPayoutDescription'),
        },
    },
}
